import { render, staticRenderFns } from "./monitoring.vue?vue&type=template&id=07248904&scoped=true&"
import script from "./monitoring.vue?vue&type=script&lang=js&"
export * from "./monitoring.vue?vue&type=script&lang=js&"
import style0 from "./monitoring.vue?vue&type=style&index=0&id=07248904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07248904",
  null
  
)

export default component.exports